export const REPORTS_TABLE_HEADERS = [
  { sortKey: 'definition.name', translation: 'reportsCount', ns: 'report' },
  { sortKey: 'updatedAt', translation: 'lastModified', ns: 'general' },
] as const;
